// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","toast-view":"Toaster_toast-view__hghIp","mode-blind":"Toaster_mode-blind__BFNhs"};